import { render } from "./ViewSubject.vue?vue&type=template&id=1c3c2632&ts=true"
import script from "./ViewSubject.ts?vue&type=script&lang=ts"
export * from "./ViewSubject.ts?vue&type=script&lang=ts"

import "./ViewSubject.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__